

export class StartEnd {
  start: string;
  ends: string[] = [];

  constructor(start?: string, end?: string) {
    this.start = start;
    // if (end) {
    //  if (this.ends.indexOf(end) <= -1) {
    this.ends.push(end);
    //  }
    // }
  }
}
